import { render, staticRenderFns } from "./UpNextAppointmentItem.vue?vue&type=template&id=fe539608&scoped=true&"
import script from "./UpNextAppointmentItem.vue?vue&type=script&lang=js&"
export * from "./UpNextAppointmentItem.vue?vue&type=script&lang=js&"
import style0 from "./UpNextAppointmentItem.vue?vue&type=style&index=0&id=fe539608&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe539608",
  null
  
)

export default component.exports